import React, { useEffect, useState } from 'react';
import { get, post, put, del } from '../utils/api';

const ROLE_OPTIONS = [
  { value: 'manager',     label: 'Управляющий' },
  { value: 'fin_manager', label: 'Финменеджер' },
];

const EMPTY_FORM = { name: '', username: '', password: '', role: 'manager', email: '', own_expenses_only: false };

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(EMPTY_FORM);
  const [editing, setEditing] = useState(null); // user id being edited
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () => get('/users').then(data => setUsers(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const s = f => setForm(p => ({ ...p, ...f }));

  const startEdit = (u) => {
    setEditing(u.id);
    setForm({ name: u.name, username: u.username, password: '', role: u.role, email: u.email || '', own_expenses_only: !!u.own_expenses_only });
    setErr('');
  };

  const cancel = () => { setEditing(null); setForm(EMPTY_FORM); setErr(''); };

  const save = async () => {
    if (!form.name.trim()) return setErr('Укажите имя');
    if (!form.username.trim()) return setErr('Укажите логин');
    if (!editing && !form.password) return setErr('Укажите пароль');
    setSaving(true); setErr('');
    try {
      if (editing) {
        await put(`/users/${editing}`, form);
      } else {
        await post('/users', form);
      }
      cancel();
      load();
    } catch (e) { setErr(e.message); }
    finally { setSaving(false); }
  };

  const remove = async (u) => {
    if (!window.confirm(`Удалить пользователя ${u.name}?`)) return;
    try { await del(`/users/${u.id}`); load(); }
    catch (e) { alert(e.message); }
  };

  const roleLabel = r => ROLE_OPTIONS.find(o => o.value === r)?.label || r;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Пользователи</h1>
      </div>

      <div style={{ maxWidth: 700 }}>
        {/* Form */}
        <div className="card" style={{ marginBottom: 24 }}>
          <div className="section-title" style={{ marginBottom: 16 }}>
            {editing ? 'Редактировать пользователя' : 'Новый пользователь'}
          </div>
          {err && <div className="error-msg" style={{ marginBottom: 12 }}>{err}</div>}
          <div className="form-grid">
            <div className="form-group span-2">
              <label>Имя и фамилия</label>
              <input value={form.name} onChange={e => s({ name: e.target.value })} placeholder="Иван Иванов" />
            </div>
            <div className="form-group">
              <label>Логин</label>
              <input value={form.username} onChange={e => s({ username: e.target.value })} placeholder="ivanov" />
            </div>
            <div className="form-group">
              <label>Пароль{editing ? ' (оставьте пустым)' : ''}</label>
              <input type="password" value={form.password} onChange={e => s({ password: e.target.value })} placeholder="••••••••" />
            </div>
            <div className="form-group">
              <label>Должность</label>
              <select value={form.role} onChange={e => s({ role: e.target.value })}>
                {ROLE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Email (для 2FA)</label>
              <input value={form.email} onChange={e => s({ email: e.target.value })} placeholder="user@example.com" />
            </div>
            <div className="form-group" style={{ gridColumn: '1 / -1' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input type="checkbox" checked={!!form.own_expenses_only} onChange={e => s({ own_expenses_only: e.target.checked })} />
                Видит только свои расходные операции (доходные — все)
              </label>
            </div>
          </div>
          <div style={{ marginTop: 16, display: 'flex', gap: 10 }}>
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? 'Сохранение...' : editing ? 'Сохранить' : 'Добавить'}
            </button>
            {editing && <button className="btn btn-secondary" onClick={cancel}>Отмена</button>}
          </div>
        </div>

        {/* Users list */}
        <div className="card">
          <div className="section-title" style={{ marginBottom: 16 }}>Список пользователей</div>
          {users.filter(u => u.role !== 'admin').length === 0 && (
            <div style={{ color: 'var(--text3)', fontSize: 14 }}>Пользователи не добавлены</div>
          )}
          {users.filter(u => u.role !== 'admin').map(u => (
            <div key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 0', borderBottom: '1px solid var(--border)' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{u.name}</div>
                <div style={{ fontSize: 13, color: 'var(--text2)' }}>@{u.username} · {roleLabel(u.role)}{u.email ? ` · ${u.email}` : ''}{u.own_expenses_only ? ' · только свои расходы' : ''}</div>
              </div>
              <button className="btn btn-secondary" style={{ padding: '4px 12px', fontSize: 13 }} onClick={() => startEdit(u)}>Изменить</button>
              <button className="btn" style={{ padding: '4px 12px', fontSize: 13, color: 'var(--red)' }} onClick={() => remove(u)}>Удалить</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
